import { render } from "./WorkingPosition.vue?vue&type=template&id=3ccd4c28&scoped=true"
import script from "./WorkingPosition.vue?vue&type=script&lang=js"
export * from "./WorkingPosition.vue?vue&type=script&lang=js"

import "./WorkingPosition.vue?vue&type=style&index=0&id=3ccd4c28&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccd4c28"]])

export default __exports__